import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, LockIcon } from 'lucide-react';
import { Logo } from './Logo';
import { PathSwitch } from './PathSwitch';
import type { PathKey } from '../types/content';
interface SiteHeaderProps {
  path: PathKey;
  onPathChange: (path: PathKey) => void;
}
const navByPath: Record<PathKey, Array<{
  label: string;
  href: string;
}>> = {
  decouverte: [{
    label: "L'ULM",
    href: '#lulm'
  }, {
    label: 'Les 6 classes',
    href: '#classes'
  }, {
    label: 'Se former',
    href: '#former'
  }, {
    label: 'Trouver une base',
    href: '#bases'
  }, {
    label: 'Questions',
    href: '#questions'
  }],
  licencie: [{
    label: 'Mes démarches',
    href: '#demarches'
  }, {
    label: 'Sécurité',
    href: '#securite'
  }, {
    label: 'Agenda fédéral',
    href: '#agenda'
  }, {
    label: 'Actualités',
    href: '#actualites'
  }, {
    label: 'La Fédération',
    href: '#federation'
  }]
};
export function SiteHeader({
  path,
  onPathChange
}: SiteHeaderProps) {
  const [open, setOpen] = useState(false);
  const links = navByPath[path];
  useEffect(() => {
    setOpen(false);
  }, [path]);
  return <header className="sticky top-0 z-50 w-full border-b border-line bg-white/95 backdrop-blur" data-id="element-232" data-mp="2ei3wb9huk1a5">
      <div className="mx-auto flex max-w-shell items-center gap-6 px-5 py-3 lg:px-8" data-id="element-233" data-mp="2jhq7lde477gb">
        <a href="#top" className="ffp-focus flex items-center gap-3 rounded" data-id="element-234" data-mp="2ohmd5h2gn6xz">
          <Logo data-id="element-235" data-mp="1qtc96wj46948" />
          <span className="leading-tight" data-id="element-236" data-mp="1qtkjcgnur0bq">
            <span className="ffp-display block text-[15px] font-extrabold uppercase text-ink" data-id="element-237" data-mp="1quvrsts8sw96">FFPLUM</span>
            <span className="block text-[11px] font-medium text-navy/70" data-id="element-238" data-mp="1vsovng62pe6a">Fédération Française d’ULM</span>
          </span>
        </a>

        <nav aria-label="Navigation principale" className="ml-auto hidden items-center gap-7 lg:flex" data-id="element-239" data-mp="25i8ewmxp7a1o">
          {links.map(link => <a key={link.href} href={link.href} className="ffp-focus rounded text-[14px] font-medium text-ink/75 transition-colors duration-150 ease-soft hover:text-azure" data-id="element-240" data-mp="181rw72vgs9bx">
              {link.label}
            </a>)}
        </nav>

        <div className="ml-auto flex items-center gap-3 lg:ml-0" data-id="element-241" data-mp="1013qotfpurcn">
          <div className="hidden md:block" data-id="element-242" data-mp="1eqrrzunwdq0d">
            <PathSwitch path={path} onPathChange={onPathChange} size="sm" data-id="element-243" data-mp="1epq60v5cfj3v" />
          </div>
          <a href="#espaces" className="ffp-focus hidden items-center gap-2 rounded-full bg-navy px-4 py-2 text-[13px] font-semibold text-white transition-colors duration-150 ease-soft hover:bg-ink lg:inline-flex" data-id="element-244" data-mp="19t9ers2ukomk">
            <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-245" data-mp="w0jr7j7o7bnc" />
            Espace licencié
          </a>
          <button type="button" onClick={() => setOpen(value => !value)} aria-expanded={open} aria-label={open ? 'Fermer le menu' : 'Ouvrir le menu'} className="ffp-focus rounded-md border border-line p-2 text-ink lg:hidden" data-id="element-246" data-mp="r1qe3rwapmnp">
            {open ? <XIcon className="h-5 w-5" data-id="element-247" data-mp="29zll490dspzr" /> : <MenuIcon className="h-5 w-5" data-id="element-248" data-mp="29zd7gewfpgni" />}
          </button>
        </div>
      </div>

      {open && <div className="border-t border-line bg-white px-5 pb-5 pt-4 lg:hidden" data-id="element-249" data-mp="2f0ssi6ym3n5w">
          <div className="md:hidden" data-id="element-250" data-mp="210hzax9txwhk">
            <PathSwitch path={path} onPathChange={onPathChange} size="sm" data-id="element-251" data-mp="211je9ctyv34k" />
          </div>
          <nav aria-label="Navigation mobile" className="mt-4 flex flex-col" data-id="element-252" data-mp="251bnzsv3jfbi">
            {links.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="ffp-focus border-b border-line py-3 text-[15px] font-medium text-ink" data-id="element-253" data-mp="2ssywyvsek5pi">
                {link.label}
              </a>)}
          </nav>
          <a href="#espaces" onClick={() => setOpen(false)} className="ffp-focus mt-4 inline-flex items-center gap-2 rounded-full bg-navy px-4 py-2.5 text-[13px] font-semibold text-white" data-id="element-254" data-mp="3bpqp7upx9v5p">
            <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-255" data-mp="1ssoovmhiexi4" />
            Espace licencié
          </a>
        </div>}
    </header>;
}